import { PRINT_TONE, PrintTone } from "@/components/print/print-tone.ts";
import { Stack, Text } from "@skailer-com/uikit";
import { ReactNode } from "react";

export function PrintLogo({ className }: { className: string }) {
  return <img src="/favicon.svg" alt="" className={className} />;
}

export function PrintLabel({
  children,
  tone = "muted",
}: {
  children: ReactNode;
  tone?: PrintTone;
}) {
  return (
    <Text className={`font-sub-headline text-xs font-medium uppercase ${PRINT_TONE[tone]}`}>
      {children}
    </Text>
  );
}

export function PrintValue({ children, accent }: { children: ReactNode; accent?: boolean }) {
  return (
    <Text className={`font-sub-headline text-sm text-default ${accent ? "font-medium" : ""}`}>
      {children}
    </Text>
  );
}

export function PrintField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <Stack gap="xs">
      <PrintLabel>{label}</PrintLabel>
      {children}
    </Stack>
  );
}
